// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1wVgA","colMaxWidth":"Table_colMaxWidth__34pXY"};